import React, { useState } from 'react';
import '../styles/FAQ.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'Quais são os benefícios de utilizar suas soluções tecnológicas?',
      answer:
        'Nossas soluções tecnológicas são projetadas para melhorar a eficiência, segurança e escalabilidade dos seus sistemas, resultando em maior produtividade e economia de custos para sua empresa.',
    },
    {
      question: 'Como funciona o processo de desenvolvimento personalizado?',
      answer:
        'Nosso processo de desenvolvimento é dividido em etapas: análise de requisitos, design, desenvolvimento, testes e entrega. Garantimos personalização total em cada fase.',
    },
    {
      question: 'Quais tecnologias vocês utilizam no desenvolvimento dos projetos?',
      answer:
        'Utilizamos tecnologias modernas como React, Node.js, PHP, MySQL, MongoDB, AWS e muitas outras para garantir alta performance e segurança.',
    },
    {
      question: 'Vocês oferecem suporte após a implementação do projeto?',
      answer:
        'Sim, oferecemos suporte técnico contínuo para garantir que suas soluções estejam sempre funcionando perfeitamente.',
    },
    {
      question: 'Como a integração de sistemas pode beneficiar minha empresa?',
      answer:
        'A integração de sistemas melhora a comunicação entre diferentes setores, reduz erros operacionais e aumenta a produtividade.',
    },
    {
      question: 'Quais são os prazos para a conclusão dos projetos?',
      answer:
        'Os prazos variam conforme a complexidade do projeto, mas sempre buscamos cumprir os cronogramas acordados com nossos clientes.',
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <h2 className="section-title">PERGUNTAS FREQUENTES</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <span>{faq.question}</span>
              {activeIndex === index ? (
                <FaChevronUp className="faq-icon" />
              ) : (
                <FaChevronDown className="faq-icon" />
              )}
            </div>
            {activeIndex === index && <p className="faq-answer">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
